/* ============================================================================
   Judge.me Product Reviews — behavior overrides.
   Suppress the up-and-down scroll bounce that Judge.me's widget triggers
   after pagination clicks. The widget's own AJAX handler scrolls the
   widget back into view after the new reviews render, and the layout
   shift makes that scroll fire twice / overshoot.

   Strategy: wrap every scroll API at script load (not on click) so that
   *whatever* reference Judge.me has captured already points at our
   wrappers. A `blocking` flag, set for ~1.5s after a pagination click,
   short-circuits the wrappers to no-ops. We cover:
     - window.scrollTo / scroll / scrollBy
     - Element.prototype.scrollIntoView
     - the `scrollTop` setter on Element / HTMLElement (catches direct
       assignment like `documentElement.scrollTop = X`)

   This file MUST load synchronously *before* judgeme_core so the wrapping
   is in place by the time the Judge.me CDN script executes.
   ============================================================================ */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var WIDGET_ID = 'judgeme_product_reviews';
  var BLOCK_MS = 1500;

  var blocking = false;
  var releaseTimer = null;

  function startBlocking() {
    blocking = true;
    if (releaseTimer) clearTimeout(releaseTimer);
    releaseTimer = setTimeout(function () { blocking = false; }, BLOCK_MS);
  }

  // ---- Wrap window scroll methods ----------------------------------------
  var origScrollTo = window.scrollTo;
  var origScroll = window.scroll;
  var origScrollBy = window.scrollBy;

  window.scrollTo = function () {
    if (blocking) return;
    return origScrollTo.apply(this, arguments);
  };
  window.scroll = function () {
    if (blocking) return;
    return origScroll.apply(this, arguments);
  };
  window.scrollBy = function () {
    if (blocking) return;
    return origScrollBy.apply(this, arguments);
  };

  // ---- Wrap Element.prototype.scrollIntoView -----------------------------
  var origScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (blocking) return;
    return origScrollIntoView.apply(this, arguments);
  };

  // ---- Wrap the scrollTop setter so direct assignment is intercepted -----
  function wrapScrollTopSetter(proto) {
    if (!proto) return;
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'scrollTop');
    if (!descriptor || typeof descriptor.set !== 'function') return;
    var origSetter = descriptor.set;
    Object.defineProperty(proto, 'scrollTop', {
      configurable: true,
      enumerable: descriptor.enumerable,
      get: descriptor.get,
      set: function (value) {
        if (
          blocking &&
          (this === document.documentElement || this === document.body)
        ) {
          return;
        }
        return origSetter.call(this, value);
      }
    });
  }
  wrapScrollTopSetter(Element.prototype);
  if (typeof HTMLElement !== 'undefined') {
    wrapScrollTopSetter(HTMLElement.prototype);
  }

  // ---- Trigger blocking on pagination clicks -----------------------------
  // Capture phase + pointerdown so we set the flag before Judge.me's own
  // bound handlers run on the same click.
  function maybeBlock(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var widget = document.getElementById(WIDGET_ID);
    if (!widget || !widget.contains(target)) return;
    if (!target.closest('.jdgm-paginate__page')) return;
    startBlocking();
  }

  document.addEventListener('pointerdown', maybeBlock, true);
  document.addEventListener('click', maybeBlock, true);
})();
